import React from 'react';
import { useNavigate } from 'react-router';
import { Client } from 'axiosApi/models';
import { HiOutlinePencilAlt } from 'react-icons/hi';
import intl from 'components/i18n/ReactIntlWrapper';

type projectRowProps = {
    id: number,
    name: string,
    client: Client,
    className: string
}
const ProjectRow = ({ id, name, client, className }: projectRowProps) => {

    const navigate = useNavigate();

    const handleClickRow = () => {
        navigate('/project/detail/' + id);
    };

    return (
        <>
            {
                name ?
                <tr className={className} style={{cursor: "default"}}>
                    <td>{name}</td>
                    <td>{client.name}</td>
                    <td className='text-center'>
                        <a className='td-icon mx-1' style={{cursor: "pointer"}} onClick={handleClickRow} title={intl.get('roleRow.editButton.title')}>
                            <HiOutlinePencilAlt/>
                        </a>
                    </td>
                </tr> :
                null
            }
        </>
    )
}

export default ProjectRow;
